export default __webpack_public_path__ + "static/media/1666.2cd46396.png";